module.exports = __webpack_public_path__ + "img/beneficio-retiro.e9bbce39.svg";